import { configureStore } from '@reduxjs/toolkit';

import {
  CLEAR_BOOKING_DATA,
  RECEIVE_AZURE_DATA,
  RECEIVE_B2C_DATA,
  RECEIVE_BOOKING_DATA,
  SET_B2C_UPDATE_STATUS,
  SET_PASSENGER_UPDATE_STATUS,
} from './SearchActions';

const initialState = {
  data: undefined,
  nameUpdated: [],
};

function searchReducer(state = initialState, { type, ...action }) {
  switch (type) {
    case RECEIVE_BOOKING_DATA:
      return {
        ...state,
        data: action.bookingData,
      };
    case RECEIVE_AZURE_DATA:
      return {
        ...state,
        azureData: action.azureData,
      };
    case RECEIVE_B2C_DATA:
      return {
        ...state,
        b2cUserData: action.b2cUserData,
      };
    case SET_B2C_UPDATE_STATUS:
      return {
        ...state,
        b2cUpdateStatus: {
          message: action.message,
        },
      };
    case CLEAR_BOOKING_DATA:
      return {
        ...state,
        data: undefined,
      };
    case SET_PASSENGER_UPDATE_STATUS: {
      if (action.pax) {
        return {
          ...state,
          passengerUpdateStatus: {
            message: action.message,
            pax: action.pax,
          },
        };
      }
      return {
        ...state,
        passengerUpdateStatus: null,
      };
    }
    default:
      return state;
  }
}

const store = configureStore({
  reducer: searchReducer,
});

export { searchReducer };
export default store;
